export default __webpack_public_path__ + "static/jaysquared_events_home-d7a80054beeadf2c0aa05d6d02b1e8cc.png";